import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

const createSouscriptionSchema = z.object({
  code: z.string().optional(),
  paymentId: z.string().optional(),
  rateId: z.string(),
  userId: z.string(),
  valid_from: z.coerce.date().optional(),
  valid_to: z.coerce.date(),
  is_active: z.boolean().optional(),
  rateid: z.string().optional(),
});

export class CreateSouscriptionDto extends createZodDto(createSouscriptionSchema) {}
